import PropTypes from 'prop-types';
import BulletinTeaser from "features/bulletins/components/BulletinTeaser";
import FilterControls from "features/view/components/Filters/FilterControls";
import Alert from "components/ui/Alert/Alert";
import Filters from "features/view/components/Filters/Filters";
import { useView } from "features/view/context/ViewContext";
import Empty from "features/view/components/Empty/Empty";
import Trans from "features/translation/components/Trans";
import Loader from "components/ui/Loader/Loader";
import ViewPager from "features/view/components/Pager/ViewPager";

const ViewBulletins = ({ layoutPersonal = false }) => {
  const { view, isLoading } = useView();

  if (!isLoading && !view) {
    return <Alert/>;
  }

  let results = view?.search_results && view.search_results.map(
      (row, index) => <BulletinTeaser key={ index }
                                      data={ row }
                                      teaserVariant={ layoutPersonal ? 'dark' : undefined }
                                      buttonVariant={ layoutPersonal ? 'white' : undefined }
                                      labelVariant={ layoutPersonal ? 'light' : undefined }
                                      hideUserDetail={ layoutPersonal }/>);

  if (!results && !isLoading) {
    results = <Empty><Trans text="Er zijn geen berichten gevonden die aan alle filtervoorwaarden voldoen."/></Empty>;
  }

  const content = (
    <>
      <div className={ 'teasers-container--1col' }>
        { isLoading ? <Loader containerVariant={ 'center' }/> : results }
      </div>
      <ViewPager/>
    </>
  );

  if (layoutPersonal) {
    return (
      <div className={ 'teasers-container--1col' }>
        { content }
      </div>
    );
  }

  return (
    <>
      <div className={ 'grid--filter' }>
        <Filters facetGroups={ { bulletin_type: [`Prikbord`] } } hasLocation={ true }/>
      </div>

      <div className={ 'grid--content' }>
        <FilterControls/>
        { content }
      </div>
    </>
  );
}

ViewBulletins.propTypes = {
  layoutPersonal: PropTypes.bool,
}

export default ViewBulletins;
